/*
 * tk-pin-product.js — připne zvolené produkty na první místa mřížky kolekce.
 *
 * Kontext: produktovou mřížku na kolekcích rendruje Globo client-side (#gf-products),
 * takže přepis pořadí v Liquidu by Globo zahodil. Řešíme až po renderu: najdeme
 * <li data-product-id> pinnutých produktů mezi PŘÍMÝMI potomky #gf-products a přesuneme
 * je na začátek v zadaném pořadí. Přesouváme existující karty (ne klony) → přirozeně
 * respektuje filtr (mimo filtr Globo kartu nevyrenderuje → přeskočí se) a nevznikají duplikáty.
 *
 * Dvě sady ID, obě dodává snippets/stylesheets.liquid (jen collection template):
 *   window.tkPinnedProductIds      — ruční piny z theme settings; platí VŽDY, i po změně řazení.
 *   window.tkSaleFirstProductIds   — zlevněné produkty kolekce; jdou za piny a uplatní se jen ve
 *                                    výchozím řazení kolekce (vlastní ?sort_by= zákazníka nepřebíjíme).
 *   window.tkCollectionDefaultSort — výchozí sort_by kolekce, pro rozpoznání „vlastní volby".
 */
(function () {
  'use strict';

  var pinnedIds = (Array.isArray(window.tkPinnedProductIds) ? window.tkPinnedProductIds : []).map(String);
  var saleIds = (Array.isArray(window.tkSaleFirstProductIds) ? window.tkSaleFirstProductIds : []).map(String);
  // Produkt v obou sadách by se do mřížky vkládal dvakrát → pořadí by nikdy „nesedělo" a observer
  // by se zacyklil. Ruční pin má přednost.
  saleIds = saleIds.filter(function (id) { return pinnedIds.indexOf(id) === -1; });
  if (!pinnedIds.length && !saleIds.length) return;

  var defaultSort = String(window.tkCollectionDefaultSort || '');
  var GRID_SEL = '#gf-products, ul.product-grid';
  var VISIBLE_SEL = ':scope > li[data-product-id]:not(.hidden-box):not(.gf-empty)';

  // Zlevněné nahoru jen dokud si zákazník nezvolí vlastní řazení (Globo i theme drží sort v URL).
  function saleFirstActive() {
    if (!saleIds.length) return false;
    var sort;
    try {
      sort = new URL(window.location.href).searchParams.get('sort_by');
    } catch (e) {
      return true;
    }
    return !sort || sort === defaultSort;
  }

  function currentIds() {
    return saleFirstActive() ? pinnedIds.concat(saleIds) : pinnedIds;
  }

  function cardFor(grid, id) {
    // Direct <li> potomek (vnořené elementy taky nesou data-product-id → :scope >).
    var c = grid.querySelector(':scope > li[data-product-id="' + id + '"]');
    if (!c || c.classList.contains('hidden-box') || c.classList.contains('gf-empty')) return null;
    return c;
  }

  function pin() {
    var grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    var ids = currentIds();
    if (!ids.length) return;

    // Karty pinnutých produktů, které jsou právě vyrenderované a viditelné — v pořadí dle ids.
    var cards = [];
    for (var i = 0; i < ids.length; i++) {
      var c = cardFor(grid, ids[i]);
      if (c) cards.push(c);
    }
    if (!cards.length) return; // vše vyfiltrováno / nenačteno → nic neděláme

    // Už jsou na začátku ve správném pořadí? Pak skip — zabrání zbytečné mutaci (a smyčce observeru).
    var visible = grid.querySelectorAll(VISIBLE_SEL);
    var ok = true;
    for (var j = 0; j < cards.length; j++) {
      if (visible[j] !== cards[j]) { ok = false; break; }
    }
    if (ok) return;

    // Vlož odzadu na absolutní začátek → výsledné pořadí prvních karet = dle ids.
    for (var k = cards.length - 1; k >= 0; k--) {
      grid.insertBefore(cards[k], grid.firstElementChild);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      pin();
    });
  }

  // Pozorujeme celý results-list kontejner: chytí donačtení (append do #gf-products),
  // re-render po filtru/řazení i případné znovuvytvoření gridu. Scoped = levné.
  function start() {
    var scope = document.querySelector('results-list') ||
                document.querySelector(GRID_SEL) ||
                document.body;
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
    // Globo mění filtr/řazení přes pushState → po popstate přehodnotit (sort_by mohl přibýt/zmizet).
    window.addEventListener('popstate', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
